import { DISCIPLINARY_ACTIONS_STATUS_LABELS } from 'Deer/pages/Team/DirectReports/DisciplinaryActions/constants';
import { REVIEW_MANAGE_GRID_COLUMN_ID } from 'screens/performanceReview/manageAndInsights/ReviewManage/components/ReviewManageAGGrid/reviewMangeGridConstants';

export const MODULE_KEYS_METRIC_CARDS_DEER = {
  GOAL: 'goal',
  REVIEW: 'review',
  ONE_ON_ONE: 'oneOnOne',
  DISCIPLINARY_ACTIONS: 'disciplinaryActions',
} as const;

export const GOALS_OVERVIEW_PAGE_METRIC_CARDS = {
  myData: {
    // goalsCount: 'goalsCount',
    // goalsNoCheckIn: 'goalsNoCheckIn',
    goalsAtRisk: 'goalsAtRisk',
    // goalsAverageProgress: 'goalsAverageProgress',
  },
  directReports: {
    teamMemberNoGoals: 'teamMemberNoGoals',
    teamMemberNoCheckIn: 'teamMemberNoCheckIn',
    // teamAverageProgress: 'teamAverageProgress',
    // teamCompletionRanking: 'teamCompletionRanking',
  },
  allReports: {
    teamMemberNoGoals: 'teamMemberNoGoals',
    teamMemberNoCheckIn: 'teamMemberNoCheckIn',
  },
  company: {
    teamMemberNoGoals: 'teamMemberNoGoals',
    teamMemberNoCheckIn: 'teamMemberNoCheckIn',
    teamMemberMoreThan5Goals: 'teamMemberMoreThan5Goals',
  },
} as const;

export const GOALS_METRIC_CARDS = {
  goalsAtRisk: 'goalsAtRisk',
  teamMemberNoGoals: 'teamMemberNoGoals',
  teamMemberNoCheckIn: 'teamMemberNoCheckIn',
  teamMemberMoreThan5Goals: 'teamMemberMoreThan5Goals',
} as const;

export const REVIEWS_METRIC_CARDS = {
  pendingSelfReviews: 'pendingSelfReviews',
  pendingPeerReviews: 'pendingPeerReviews',
  pendingUpwardReviews: 'pendingUpwardReviews',
  pendingManagerReviews: 'pendingManagerReviews',
  pendingDLMReviews: 'pendingDLMReviews',
  identifiedForCalibration: 'identifiedForCalibration',
  noRatingChange: 'noRatingChange',
  pendingCalibration: 'pendingCalibration',
} as const;

export const DISCIPLINARY_ACTIONS_METRIC_CARDS = {
  awaitingAdminApproval: 'awaitingAdminApproval',
  awaitingManagerPublish: 'awaitingManagerPublish',
  awaitingEmployeeAcknowledgement: 'awaitingEmployeeAcknowledgement',
} as const;

export const DISCIPLINARY_ACTIONS_ADMIN_REPORTS_METRIC_CARDS = {
  employeesWithViolations: 'employeesWithViolations',
  highSeverityViolations: 'highSeverityViolations',
  greaterThanThreeViolations: 'greaterThanThreeViolations',
  pendingAcknowledgement: 'pendingAcknowledgement',
};

// for metric cards on same page as the table
// export const getGoalsFilterWithOutTarget = ({ module, key }) => {
//   const filterData = GOALS_METRIC_CARDS_META?.[module]?.[key];
//   if (!filterData) return {};
//   // eslint-disable-next-line @typescript-eslint/no-unused-vars
//   const { targetPage, ...filters } = filterData;
//   return { filters };
// };

const goalsFilters = {
  goalsAtRisk: {
    filters: {
      'table-status': {
        filterType: 'multi',
        filterModels: [
          {
            values: ['AT_RISK'],
            filterType: 'set',
          },
          null,
          null,
        ],
      },
    },
    filterKeysToClear: ['table-status'],
  },

  teamMemberNoGoals: {
    filters: {
      'kr-count': {
        filterType: 'multi',
        filterModels: [
          {
            filterType: 'number',
            type: 'equals',
            filter: 0,
          },
          null,
        ],
      },
    },
    filterKeysToClear: ['kr-count'],
  },

  teamMemberNoCheckIn: {
    filters: {
      'checkin-count': {
        filterType: 'multi',
        filterModels: [
          {
            filterType: 'number',
            type: 'equals',
            filter: 0,
          },
          null,
        ],
      },
    },
    filterKeysToClear: ['checkin-count'],
  },

  teamMemberMoreThan5Goals: {
    filters: {
      'kr-count': {
        filterType: 'multi',
        filterModels: [
          {
            filterType: 'number',
            type: 'greaterThanOrEqual',
            filter: 5,
          },
          null,
        ],
      },
    },
    filterKeysToClear: ['kr-count'],
  },
};

export const GOALS_METRIC_CARDS_META = {
  // [GOALS_METRIC_CARDS.goalsAtRisk]: goalsFilters.goalsAtRisk,
  // [GOALS_METRIC_CARDS.teamMemberNoGoals]: goalsFilters.teamMemberNoGoals,
  // [GOALS_METRIC_CARDS.teamMemberNoCheckIn]: goalsFilters.teamMemberNoCheckIn,
  // [GOALS_METRIC_CARDS.teamMemberMoreThan5Goals]: goalsFilters.teamMemberMoreThan5Goals,
};

export const GOALS_OVERVIEW_PAGE_METRIC_CARDS_META = {
  myData: {
    // [GOALS_OVERVIEW_PAGE_METRIC_CARDS.myData.goalsAtRisk]: {
    //   targetPage: L3_PATHS['my-data'].goal.myGoals,
    //   ...goalsFilters.goalsAtRisk,
    // },
  },
  directReports: {
    // [GOALS_OVERVIEW_PAGE_METRIC_CARDS.directReports.teamMemberNoGoals]: {
    //   targetPage: L3_PATHS.team.directReports.goal.manage,
    //   targetPageQueryParams: {
    //     groupByViewType: 'INDIVIDUAL',
    //     manageViewType: 'list',
    //   },
    //   ...goalsFilters.teamMemberNoGoals,
    // },
    // [GOALS_OVERVIEW_PAGE_METRIC_CARDS.directReports.teamMemberNoCheckIn]: {
    //   targetPage: L3_PATHS.team.directReports.goal.manage,
    //   targetPageQueryParams: {
    //     groupByViewType: 'INDIVIDUAL',
    //     manageViewType: 'list',
    //   },
    //   ...goalsFilters.teamMemberNoCheckIn,
    // },
  },
  allReports: {
    // [GOALS_OVERVIEW_PAGE_METRIC_CARDS.allReports.teamMemberNoGoals]: {
    //   targetPage: L3_PATHS.team.allReports.goal.manage,
    //   targetPageQueryParams: {
    //     groupByViewType: 'INDIVIDUAL',
    //     manageViewType: 'list',
    //   },
    //   ...goalsFilters.teamMemberNoGoals,
    // },
    // [GOALS_OVERVIEW_PAGE_METRIC_CARDS.allReports.teamMemberNoCheckIn]: {
    //   targetPage: L3_PATHS.team.allReports.goal.manage,
    //   targetPageQueryParams: {
    //     groupByViewType: 'INDIVIDUAL',
    //     manageViewType: 'list',
    //   },
    //   ...goalsFilters.teamMemberNoCheckIn,
    // },
  },
  company: {
    //   [GOALS_OVERVIEW_PAGE_METRIC_CARDS.company.teamMemberNoGoals]: {
    //     targetPage: L3_PATHS.company.goal.manage,
    //     targetPageQueryParams: {
    //       groupByViewType: 'INDIVIDUAL',
    //       manageViewType: 'list',
    //     },
    //     ...goalsFilters.teamMemberNoGoals,
    //   },
    //   [GOALS_OVERVIEW_PAGE_METRIC_CARDS.company.teamMemberNoCheckIn]: {
    //     targetPage: L3_PATHS.company.goal.manage,
    //     targetPageQueryParams: {
    //       groupByViewType: 'INDIVIDUAL',
    //       manageViewType: 'list',
    //     },
    //     ...goalsFilters.teamMemberNoCheckIn,
    //   },
    //   [GOALS_OVERVIEW_PAGE_METRIC_CARDS.company.teamMemberMoreThan5Goals]: {
    //     targetPage: L3_PATHS.company.goal.manage,
    //     targetPageQueryParams: {
    //       groupByViewType: 'INDIVIDUAL',
    //       manageViewType: 'list',
    //     },
    //     ...goalsFilters.teamMemberMoreThan5Goals,
    //   },
  },
};

// export const ONEONONE_METRIC_CARDS_META = {
//   // myData: {},
//   directReports: {},
//   allReports: {},
//   company: {},
// };

const getReviewManageFilterForColumn = (column: string) => ({
  [column]: {
    filterType: 'multi',
    filterModels: [
      null,
      {
        values: ['Not Started', 'In Progress'],
        filterType: 'set',
      },
      null,
    ],
  },
});

// export const REVIEWS_METRIC_CARDS_META = {
//   myData: {},
//   directReports: {
//     [REVIEWS_METRIC_CARDS.directReports.pendingSelfReviews]: {
//       filters: getReviewManageFilterForColumn('8'),
//       filterKeysToClear: ['8'],
//     },
//     [REVIEWS_METRIC_CARDS.directReports.pendingPeerReviews]: {
//       filters: getReviewManageFilterForColumn('43'),
//       filterKeysToClear: ['43'],
//     },
//     [REVIEWS_METRIC_CARDS.directReports.pendingUpwardReviews]: {
//       filters: getReviewManageFilterForColumn('44'),
//       filterKeysToClear: ['44'],
//     },
//     [REVIEWS_METRIC_CARDS.directReports.pendingManagerReviews]: {
//       filters: getReviewManageFilterForColumn('14'),
//       filterKeysToClear: ['14'],
//     },
//     [REVIEWS_METRIC_CARDS.directReports.pendingDLMReviews]: {
//       filters: getReviewManageFilterForColumn('40'),
//       filterKeysToClear: ['40'],
//     },
//   },
//   allReports: {
//     [REVIEWS_METRIC_CARDS.allReports.pendingSelfReviews]: {
//       filters: getReviewManageFilterForColumn('8'),
//       filterKeysToClear: ['8'],
//     },
//     [REVIEWS_METRIC_CARDS.allReports.pendingPeerReviews]: {
//       filters: getReviewManageFilterForColumn('43'),
//       filterKeysToClear: ['43'],
//     },
//     [REVIEWS_METRIC_CARDS.allReports.pendingUpwardReviews]: {
//       filters: getReviewManageFilterForColumn('44'),
//       filterKeysToClear: ['44'],
//     },
//     [REVIEWS_METRIC_CARDS.allReports.pendingManagerReviews]: {
//       filters: getReviewManageFilterForColumn('14'),
//       filterKeysToClear: ['14'],
//     },
//     [REVIEWS_METRIC_CARDS.allReports.pendingDLMReviews]: {
//       filters: getReviewManageFilterForColumn('40'),
//       filterKeysToClear: ['40'],
//     },
//   },
//   company: {
//     [REVIEWS_METRIC_CARDS.company.pendingSelfReviews]: {
//       filters: getReviewManageFilterForColumn('8'),
//       filterKeysToClear: ['8'],
//     },
//     [REVIEWS_METRIC_CARDS.company.pendingPeerReviews]: {
//       filters: getReviewManageFilterForColumn('43'),
//       filterKeysToClear: ['43'],
//     },
//     [REVIEWS_METRIC_CARDS.company.pendingUpwardReviews]: {
//       filters: getReviewManageFilterForColumn('44'),
//       filterKeysToClear: ['44'],
//     },
//     [REVIEWS_METRIC_CARDS.company.pendingManagerReviews]: {
//       filters: getReviewManageFilterForColumn('14'),
//       filterKeysToClear: ['14'],
//     },
//     [REVIEWS_METRIC_CARDS.company.pendingDLMReviews]: {
//       filters: getReviewManageFilterForColumn('40'),
//       filterKeysToClear: ['40'],
//     },
//   },
//   view: {
//     [REVIEWS_METRIC_CARDS.view.pendingSelfReviews]: {
//       filters: getReviewManageFilterForColumn('8'),
//       filterKeysToClear: ['8'],
//     },
//     [REVIEWS_METRIC_CARDS.view.pendingPeerReviews]: {
//       filters: getReviewManageFilterForColumn('43'),
//       filterKeysToClear: ['43'],
//     },
//     [REVIEWS_METRIC_CARDS.view.pendingUpwardReviews]: {
//       filters: getReviewManageFilterForColumn('44'),
//       filterKeysToClear: ['44'],
//     },
//     [REVIEWS_METRIC_CARDS.view.pendingManagerReviews]: {
//       filters: getReviewManageFilterForColumn('14'),
//       filterKeysToClear: ['14'],
//     },
//     [REVIEWS_METRIC_CARDS.view.pendingDLMReviews]: {
//       filters: getReviewManageFilterForColumn('40'),
//       filterKeysToClear: ['40'],
//     },
//   },
// };

export const REVIEWS_METRIC_CARDS_GRID_META = {
  [REVIEWS_METRIC_CARDS.pendingSelfReviews]: {
    filters: getReviewManageFilterForColumn(REVIEW_MANAGE_GRID_COLUMN_ID.SELF_REVIEW_STATUS),
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.SELF_REVIEW_STATUS],
  },
  [REVIEWS_METRIC_CARDS.pendingPeerReviews]: {
    filters: getReviewManageFilterForColumn(REVIEW_MANAGE_GRID_COLUMN_ID.PEER_REVIEW_STATUS),
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.PEER_REVIEW_STATUS],
  },
  [REVIEWS_METRIC_CARDS.pendingUpwardReviews]: {
    filters: getReviewManageFilterForColumn(REVIEW_MANAGE_GRID_COLUMN_ID.UPWARD_REVIEW_STATUS),
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.UPWARD_REVIEW_STATUS],
  },
  [REVIEWS_METRIC_CARDS.pendingManagerReviews]: {
    filters: getReviewManageFilterForColumn(REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_REVIEW_STATUS),
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.MANAGER_REVIEW_STATUS],
  },
  [REVIEWS_METRIC_CARDS.pendingDLMReviews]: {
    filters: getReviewManageFilterForColumn(REVIEW_MANAGE_GRID_COLUMN_ID.DLM_REVIEW_STATUS),
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.DLM_REVIEW_STATUS],
  },
  [REVIEWS_METRIC_CARDS.identifiedForCalibration]: {
    filters: {
      [REVIEW_MANAGE_GRID_COLUMN_ID.IDENTIFIED_FOR_CALIBRATION]: {
        filterType: 'multi',
        filterModels: [
          null,
          {
            values: ['Yes'],
            filterType: 'set',
          },
          null,
        ],
      },
    },
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.IDENTIFIED_FOR_CALIBRATION],
  },
  [REVIEWS_METRIC_CARDS.noRatingChange]: {
    filters: {},
    filterKeysToClear: [],
  },
  [REVIEWS_METRIC_CARDS.pendingCalibration]: {
    filters: {
      [REVIEW_MANAGE_GRID_COLUMN_ID.CALIBRATION_STATUS]: {
        filterType: 'multi',
        filterModels: [
          null,
          {
            values: ['Pending'],
            filterType: 'set',
          },
          null,
        ],
      },
    },
    filterKeysToClear: [REVIEW_MANAGE_GRID_COLUMN_ID.CALIBRATION_STATUS],
  },
};

export const DISCIPLINARY_ACTIONS_METRIC_CARDS_GRID_META = {
  [DISCIPLINARY_ACTIONS_METRIC_CARDS.awaitingAdminApproval]: {
    filters: {
      STATUS: {
        filterType: 'agSetColumnFilter',
        filterModels: [
          null,
          {
            values: [DISCIPLINARY_ACTIONS_STATUS_LABELS.CREATED],
            filterType: 'set',
          },
        ],
      },
    },
    filterKeysToClear: ['STATUS'],
  },
  [DISCIPLINARY_ACTIONS_METRIC_CARDS.awaitingManagerPublish]: {
    filters: {
      STATUS: {
        filterType: 'agSetColumnFilter',
        filterModels: [
          null,
          {
            values: [DISCIPLINARY_ACTIONS_STATUS_LABELS.APPROVED],
            filterType: 'set',
          },
        ],
      },
    },
    filterKeysToClear: ['STATUS'],
  },
  [DISCIPLINARY_ACTIONS_METRIC_CARDS.awaitingEmployeeAcknowledgement]: {
    filters: {
      STATUS: {
        filterType: 'agSetColumnFilter',
        filterModels: [
          null,
          {
            values: [DISCIPLINARY_ACTIONS_STATUS_LABELS.PUBLISHED_TO_EMPLOYEE],
            filterType: 'set',
          },
        ],
      },
    },
    filterKeysToClear: ['STATUS'],
  },
  [DISCIPLINARY_ACTIONS_ADMIN_REPORTS_METRIC_CARDS.employeesWithViolations]: {
    filters: {
      TOTAL_VIOLATIONS: {
        filterType: 'agNumberColumnFilter',
        filterModels: [
          {
            filterType: 'number',
            type: 'greaterThanOrEqual',
            filter: 1,
          },
        ],
      },
    },
    filterKeysToClear: ['TOTAL_VIOLATIONS'],
  },
  [DISCIPLINARY_ACTIONS_ADMIN_REPORTS_METRIC_CARDS.highSeverityViolations]: {
    filters: {
      VIOLATIONS_BY_SEVERITY: {
        filterType: 'agSetColumnFilter',
        filterModels: [
          {
            values: ['high'],
            filterType: 'set',
          },
        ],
      },
    },
    filterKeysToClear: ['VIOLATIONS_BY_SEVERITY'],
  },
  [DISCIPLINARY_ACTIONS_ADMIN_REPORTS_METRIC_CARDS.greaterThanThreeViolations]: {
    filters: {
      TOTAL_VIOLATIONS: {
        filterType: 'multi',
        filterModels: [
          {
            filterType: 'number',
            type: 'greaterThanOrEqual',
            filter: 4,
          },
        ],
      },
    },
    filterKeysToClear: ['TOTAL_VIOLATIONS'],
  },
  [DISCIPLINARY_ACTIONS_ADMIN_REPORTS_METRIC_CARDS.pendingAcknowledgement]: {
    filters: {
      UNACKNOWLEDGED_NOTES: {
        filterType: 'agNumberColumnFilter',
        filterModels: [
          {
            filterType: 'number',
            type: 'greaterThanOrEqual',
            filter: 1,
          },
        ],
      },
    },
    filterKeysToClear: ['UNACKNOWLEDGED_NOTES'],
  },
};
export const MODULE_WISE_METRIC_CARDS = {
  [MODULE_KEYS_METRIC_CARDS_DEER.GOAL]: GOALS_METRIC_CARDS_META,
  [MODULE_KEYS_METRIC_CARDS_DEER.REVIEW]: REVIEWS_METRIC_CARDS_GRID_META,
  [MODULE_KEYS_METRIC_CARDS_DEER.DISCIPLINARY_ACTIONS]: DISCIPLINARY_ACTIONS_METRIC_CARDS_GRID_META,
  // [MODULE_KEYS_METRIC_CARDS_DEER.ONE_ON_ONE]: ONEONONE_METRIC_CARDS_META,
};

export const MODULE_WISE_OVERVIEW_PAGE_METRIC_CARDS = {
  [MODULE_KEYS_METRIC_CARDS_DEER.GOAL]: GOALS_OVERVIEW_PAGE_METRIC_CARDS_META,
};

export const demoAICalibrationEnabledEmployees = ['50716', '50723', '50700', '50705', '50715', '50721'];
export const demoAICalibrationNudges = {
  '50716': {
    title:
      "Bianca Hardy has been identified for calibration because her self-rating differs significantly from her manager Mark Clarke's rating.",
    summary: [],
    description:
      "Bianca's self-rating is 5 (“Outstanding”), while Mark rated her as 2 (“Needs Improvement”). This difference of 3 levels on a 5-point scale indicates a significant misalignment in performance perceptions. The calibration committee should discuss this discrepancy to understand the underlying reasons.",
  },
  '50723': {
    title: 'Alex Spencer has been identified for calibration because:',
    summary: [
      "His peer feedback contradicts his manager Sibley Bourn's rating.",
      'His performance ratings do not have supporting comments.',
    ],
    description:
      "Alex received consistently positive peer feedback, with peers praising his teamwork and leadership skills. However, Sibley rated him as 2 (“Needs Improvement”) without providing any qualitative comments or examples to support the low rating. This contradiction suggests differing perceptions of his performance and a lack of substantiation for the manager's rating.",
  },
  '50700': {
    title:
      'Carlos Jiron has been identified for calibration because he is a high performer who has been overlooked for promotion for the past two cycles',
    summary: [],
    description:
      'Carlos has received performance ratings of 5 (“Outstanding”) for the past three review cycles, yet he has not been considered for promotion during his four years in the current role. This may pose a retention risk as his contributions have not been recognized through advancement.',
  },
  '50705': {
    title: 'Mark Clarke has been marked for calibration because:',
    summary: [
      'There is a sudden change in his performance rating compared to the previous review cycle.',
      'He has received mixed peer feedback.',
    ],
    description:
      "Mark's performance rating dropped from a 4 (“Exceeds Expectations”) last cycle to a 2 (“Needs Improvement”) this cycle. Additionally, his peer feedback shows a high variance, with some peers highlighting his strong analytical skills while others note concerns about meeting deadlines. This abrupt change and polarized feedback warrant further investigation.",
  },
  '50715': {
    title:
      'Dai Long has been identified for calibration because his manager Jay Chandra consistently rates his entire team unusually high compared to other teams.',
    summary: [],
    description:
      "Jay's team has an average performance rating of 4.8 on a 5-point scale, whereas the organizational average is 3.5. This significant difference suggests a potential leniency bias. Dai, like his teammates, received a 5 (“Outstanding”) rating, which may need to be calibrated against organizational standards.",
  },
  '50721': {
    title: 'Chloe Nunez has been identified for calibration due to:',
    summary: [
      'A discrepancy between her goal achievement and performance rating.',
      'She has not received any peer feedback.',
    ],
    description:
      "Chloe received a performance rating of 5 (“Outstanding”), while her team's average rating is 2.5. Her exceptional performance compared to her team may require recognition, and there may be opportunities to leverage her strengths to improve team performance.",
  },
};

export const REVIEW_CALIBRATION_METRIC_CARD_TYPES = {
  IDENTIFICATION: 'IDENTIFIED_FOR_CALIBRATION',
  CALIBRATION_STATUS: 'CALIBRATION_STATUS',
};
